import { EARLY_FREEDOM_SAFE_WITHDRAWAL_YEARS } from "web_myplann/Inspiration/EarlyFreedom/constants";
import type { EarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

export const getEarlyFreedomTargetYears = (
	context: EarlyFreedomContext,
): number =>
	context.scenarios.find(
		(scenario) => scenario.key === context.selectedScenario,
	)?.years ?? EARLY_FREEDOM_SAFE_WITHDRAWAL_YEARS;
